import { Button } from "@/components/ui/button";

export function QueryError({
  error,
  onRetry,
  hasData = false,
  busy = false,
  noun = "data",
}: {
  error: unknown;
  onRetry: () => void;
  hasData?: boolean;
  busy?: boolean;
  noun?: string;
}) {
  const signIn = error instanceof Error && /^401\b/.test(error.message);
  return (
    <div
      role="alert"
      className="rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm space-y-2"
    >
      <p>
        {signIn
          ? "Your session expired. Sign in to continue."
          : hasData
            ? `Couldn't refresh ${noun}. Showing previously loaded data; it may be out of date.`
            : `Couldn't load ${noun}. Please try again.`}
      </p>
      {signIn ? (
        <a
          className="underline font-medium"
          href={`/auth/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`}
        >
          Sign in
        </a>
      ) : (
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={busy}
          onClick={onRetry}
        >
          {busy ? "Retrying…" : "Retry"}
        </Button>
      )}
    </div>
  );
}
